export default __webpack_public_path__ + "static/media/settings.a57f3029.svg";